import { VisitorTypeReducerState } from "../VisitorType/classes/visitorType.classes";
import { AgeReducerState } from "../Age/classes/age.classes";
import { GeographyReducerState } from "../Geography/classes/geography.classes";
import { GenderReducerState } from "../Gender/classes/gender.classes";
import { EthnicityReducerState } from "../Ethnicity/classes/ethnicity.classes";

export class DemographicsReducerState {
  visitorType: VisitorTypeReducerState;
  geography: GeographyReducerState;
  age: AgeReducerState;
  gender: GenderReducerState;
  ethnicity: EthnicityReducerState;

  constructor(
    visitorType?: VisitorTypeReducerState,
    geography?: GeographyReducerState,
    age?: AgeReducerState,
    gender?: GenderReducerState,
    ethnicity?: EthnicityReducerState
  ) {
    this.visitorType = visitorType || new VisitorTypeReducerState();
    this.geography = geography || new GeographyReducerState();
    this.age = age || new AgeReducerState();
    this.gender = gender || new GenderReducerState();
    this.ethnicity = ethnicity || new EthnicityReducerState();
  }
}
